module.exports = __webpack_public_path__ + "c569a183617e43804108472d6db16bf3.png";